import { render, staticRenderFns } from "./MaterialSettings.vue?vue&type=template&id=51cdff70&scoped=true&"
import script from "./MaterialSettings.vue?vue&type=script&lang=js&"
export * from "./MaterialSettings.vue?vue&type=script&lang=js&"
import style0 from "./MaterialSettings.vue?vue&type=style&index=0&id=51cdff70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdff70",
  null
  
)

export default component.exports